var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8535 4.25H1.5C1.08579 4.25 0.75 3.91421 0.75 3.5C0.75 3.08579 1.08579 2.75 1.5 2.75H10.8535C11.18 1.59575 12.2412 0.75 13.5 0.75C14.7588 0.75 15.82 1.59575 16.1465 2.75H17.5C17.9142 2.75 18.25 3.08579 18.25 3.5C18.25 3.91421 17.9142 4.25 17.5 4.25H16.1465C15.82 5.40425 14.7588 6.25 13.5 6.25C12.2412 6.25 11.18 5.40425 10.8535 4.25ZM12.25 3.5C12.25 2.80964 12.8096 2.25 13.5 2.25C14.1904 2.25 14.75 2.80964 14.75 3.5C14.75 4.19036 14.1904 4.75 13.5 4.75C12.8096 4.75 12.25 4.19036 12.25 3.5Z",
    fill: "#347AE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14648 12.25H17.5C17.9142 12.25 18.25 11.9142 18.25 11.5C18.25 11.0858 17.9142 10.75 17.5 10.75H8.14648C7.82002 9.59575 6.75878 8.75 5.5 8.75C4.24122 8.75 3.17998 9.59575 2.85352 10.75H1.5C1.08579 10.75 0.75 11.0858 0.75 11.5C0.75 11.9142 1.08579 12.25 1.5 12.25H2.85352C3.17998 13.4043 4.24122 14.25 5.5 14.25C6.75878 14.25 7.82002 13.4043 8.14648 12.25ZM4.25 11.5C4.25 10.8096 4.80964 10.25 5.5 10.25C6.19036 10.25 6.75 10.8096 6.75 11.5C6.75 12.1904 6.19036 12.75 5.5 12.75C4.80964 12.75 4.25 12.1904 4.25 11.5Z",
    fill: "#347AE6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.03e77193.svg";
export { ForwardRef as ReactComponent };